var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogofooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_65315",
    "data-name": "Group 65315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.622,
    height: 38.015,
    viewBox: "0 0 93.622 38.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M690.093,81.3a9.9,9.9,0,1,1-13.6,9.092,9.637,9.637,0,0,1,.125-1.512l-6.946,7.966a18.033,18.033,0,0,0,21.443,10.889,17.8,17.8,0,0,0,11.877-24.5,17.574,17.574,0,0,0-7.74-8.269Z",
    transform: "translate(-669.667 -74.966)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(58.726 2.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 37.867,
    height: 35.087,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M705.524,54.351l-5.321,6.54a9.345,9.345,0,0,0-1.83-.193,10.412,10.412,0,0,0-7.383,2.915l-6.374,7.471a8.492,8.492,0,0,0-1.5-9.594c-.232-.244-.408-.363-.577-.367q.757-.9,1.512-1.8a18.38,18.38,0,0,1,21.468-4.968Z",
    transform: "translate(-622.546 -52.805)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M135.628,83.959c-.235-.242-.41-.363-.578-.366q-8.549,10.191-17.219,20.285a3.9,3.9,0,0,1-4.852-3.779c0-.084,0-.166.008-.247,0-.063.01-.125.016-.189a.187.187,0,0,1,.006-.044c.109-.128.216-.257.325-.383q1.039-1.229,2.079-2.453l.355-.422q2.7-3.18,5.409-6.354l.162-.189q4.116-4.825,8.236-9.649a1.38,1.38,0,0,0,.311-.5c-.041-.149-.181-.288-.436-.456a8.088,8.088,0,0,0-10.082.916c-.8.791-1.512,1.672-2.244,2.527-2.193,2.567-4.376,5.143-6.666,7.835-.021-.051-.04-.1-.057-.141-.162-.4-.277-.683-.388-.97A18.005,18.005,0,0,0,93.154,77.737a18.561,18.561,0,0,0-4.649.594,17.8,17.8,0,0,0-11.877,24.5c5.481,12.034,22.016,14.132,30.535,3.944.127-.154.254-.3.38-.458a11.209,11.209,0,0,0,9.128,5.061c.084,0,.171,0,.257,0a11.193,11.193,0,0,0,7.628-2.992l1.775-2.1q.09-.133.171-.271c.035-.038.067-.079.1-.119,1.882-2.2,3.757-4.411,5.7-6.694l3.579-4.2.063-.074,1.182-1.385A8.5,8.5,0,0,0,135.628,83.959ZM92.921,105.394h-.073a10.256,10.256,0,1,1,.073,0Z",
    transform: "translate(-75.052 -75.275)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofooter);
export default __webpack_public_path__ + "static/media/logofooter.e076c6205750306345d5b0a87e4b1bda.svg";
export { ForwardRef as ReactComponent };